import api from 'core/api';

export const getFavorites = ({ pagination }) => api.get(`/favorites`, { params: pagination });

export const getFavorite = ({ klass, klassId }) => api.get(`/favorites/${klass}/${klassId}`);
export const postFavorite = (data) => api.post('/favorites', data);
export const deleteFavorite = (data) => api.delete(`/favorites/${data.klass}/${data.klassId}`);
